export const BASIC = {
    SET_USER: 'SET_USER',
    INIT_USER: 'INIT_USER',
    SET_MENU_IDX: 'SET_MENU_IDX',
    SET_AUTH: 'SET_AUTH',
    INIT_TOKEN: 'INIT_TOKEN',
    INIT_RTOKEN: 'INIT_RTOKEN',
    SET_APP_NAME: 'SET_APP_NAME',
    SET_CODES: 'SET_CODES',
    SET_EMAIL: 'SET_EMAIL',
}

export const VIEW = {
    SET_DATA: 'SET_DATA',
}

export const COMPANY = {
    SET_ALL_COMPANY: 'SET_ALL_COMPANY',
}
